<template>
  <div class="gallery-container">
<!--        <GalleryBar :title="gallery.name"
                v-if="gallery.name"/>-->
  </div>
</template>

<script>
import BaseDisplayType from './BaseDisplayType.vue'
import GalleryBar from "@/domain/galleryTree/components/GalleryBar.vue";

export default {
  name: 'ContainerGallery',
  components: {GalleryBar},
  extends: BaseDisplayType,

  computed: {
    displayType() {
      return 'container'
    },
    
    paginationType() {
      return 'none' // Container doesn't need pagination
    }
  },

  methods: {
    getPaginationSize() {
      return 0 // Container doesn't fetch media
    }
  }
}
</script>

<style scoped>
/* Component-specific styles only */
</style>